var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useMemo } from "react";
import styled from "styled-components";
var Star = styled.polygon(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fill: url(#", ");\n  stroke: #ffb900;\n  stroke-width: 10;\n  fill-rule: nonzero;\n"], ["\n  fill: url(#", ");\n  stroke: #ffb900;\n  stroke-width: 10;\n  fill-rule: nonzero;\n"])), function (_a) {
    var gradientId = _a.gradientId;
    return gradientId;
});
var RatingStar = function (_a) {
    var value = _a.value, rating = _a.rating, size = _a.size, onClick = _a.onClick;
    var percentFull = useMemo(function () {
        if (rating < value) {
            return (rating - (value - 1)) * 100;
        }
        else {
            return 100;
        }
    }, [value, rating]);
    var gradientId = useMemo(function () {
        return "ratingStar_".concat(percentFull);
    }, [percentFull]);
    var gradient = useMemo(function () {
        return (React.createElement("linearGradient", { id: gradientId },
            React.createElement("stop", { offset: "0%", stopColor: "white", stopOpacity: "0" }),
            React.createElement("stop", { offset: "".concat(100 - percentFull, "%"), stopColor: "white", stopOpacity: "0" }),
            React.createElement("stop", { offset: "".concat(100 - percentFull, "%"), stopColor: "#ffb900" }),
            React.createElement("stop", { offset: "100%", stopColor: "#ffb900" })));
    }, [gradientId, percentFull]);
    var handleClick = useCallback(function () {
        if (onClick) {
            onClick(value);
        }
    }, [value]);
    return (React.createElement("svg", { height: size, width: size, viewBox: "-10 -10 220 220", onClick: handleClick },
        gradient,
        React.createElement("g", { height: size, width: size, transform: "rotate(180 100 100)" },
            React.createElement(Star, { points: "20,0 50,80 0,130 70,130 100,195 130,130 200,130 150,80 180,0 100,50", gradientId: gradientId }))));
};
export default RatingStar;
var templateObject_1;
